<template>
    <el-card class="component-search-form">
        <el-form :inline="true" size="mini">
            <slot name="form-items"></slot>
            <el-button size="mini" type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
            <slot name="search-button-right"></slot>
        </el-form>
        <slot name="bottom"></slot>
    </el-card>
</template>

<script>
    export default {
        name: "SearchForm",
        props: {
            tableList: Object,
        },
        methods: {
            handleSearch() {
                if (!this.tableList || !this.tableList.load)
                    return Promise.resolve();
                return this.tableList.load();
            },
        }
    }
</script>

<style>
    .component-search-form .el-form .el-form-item--mini.el-form-item,
    .component-search-form .el-form .el-form-item--small.el-form-item
    {
        margin-bottom: 10px ;
    }
</style>



// WEBPACK FOOTER //
// src/components/form/SearchForm.vue